<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Hot Rodding in the San Fernando Valley</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head">C<span class="small">ONTENTS</span></p>
<table>
<colgroup>
<col width="40px"/>
<col width="350px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><span href="#/Dedication" title="Link target outside of Sample">Dedication</span></td></tr>
<tr><td colspan="2"><a href="#/Acknowledgments#Ack">Acknowledgments</a></td></tr>
<tr><td colspan="2"><a href="#/Introduction#Intro">Introduction</a></td></tr>
<tr><td><span href="#/Chapter01#C1" title="Link target outside of Sample">1.</span></td><td><span href="#/Chapter01#C1" title="Link target outside of Sample">Kings of the Valley</span></td></tr>
<tr><td><span href="#/Chapter02#C2" title="Link target outside of Sample">2.</span></td><td><span href="#/Chapter02#C2" title="Link target outside of Sample">On the Road</span></td></tr>
<tr><td><span href="#/Chapter03#C3" title="Link target outside of Sample">3.</span></td><td><span href="#/Chapter03#C3" title="Link target outside of Sample">The Drag Strip</span></td></tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?7ca221e2